import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../services/user";
import { formatDate } from "../utils";

const initialState = {
  users: []
};

export const getUsers = createAsyncThunk(
  "user/get",
  async (userInfo) => {
    const res = await userService.getUsers(userInfo);
    return res.data;
  }
)

export const createUser = createAsyncThunk(
  "user/create",
  async (userInfo) => {
    const res = await userService.createUser(userInfo);
    return res.data;
  }
);

export const updateUser = createAsyncThunk(
  "user/update",
  async (userInfo) => {
    const res = await userService.updateUser(userInfo);
    return res.data;
  }
);

export const deleteUser = createAsyncThunk(
  "user/delete",
  async (id) => {
    const res = await userService.deleteUser(id);
    return res.data;
  }
);

export const assignSourceToUser = createAsyncThunk(
  "user/assign",
  async (info) => {
    const res = await userService.assignSourceToUser(info);
    return res.data;
  }
)

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // changePermission: (state, action) => {
    //   const {module, kind} = action.payload;
    //   const newData =  state.permission.map(item => {
    //     if(item.module === module) {
    //       return {...item, [kind]: !item[kind]}
    //     }
    //     return item;
    //   });
    //   state.permission = newData;
    // },
    // changeRole: (state, action) => {
    //   const {role} = action.payload;
    //   state.role = action.payload;
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.users = action.payload;
    })
    builder.addCase(createUser.fulfilled, (state, action) => {
      const {id, email, first_name, last_name, created_at, role } = action.payload;
      const date = formatDate(created_at);
      state.users.push({
        id, email, first_name, last_name, role,created_at: date
      })
    })
    builder.addCase(updateUser.fulfilled, (state, action) => {
      const {id, email, first_name, last_name, role, created_at } = action.payload;
      const date = formatDate(created_at);
      const newUsers = state.users.map(user => {
        if (user.id === id) return {
          id, email, first_name, last_name, role, created_at: date
        } 
        else
          return user
      })
      state.users = newUsers;
    })
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      const {id, success} = action.payload;
      if(success) {
        const newUsers = state.users.filter(item => item.id !== id) 
        state.users = newUsers
      }
    })
    builder.addCase(assignSourceToUser.fulfilled, (state, action) => {
    })
  }
})

// export const {
//   changePermission, 
//   changeRole
// } = permissionSlice.actions;

const { reducer } = userSlice;
export default reducer;